import React, { Component } from 'react';
import './banner.scss';
import { API, InitConfig } from '../common/config';
import { Event } from '../common/event';

export default class Banner extends Component {

  constructor(props) {
    super(props);
    this.state = {
      category: [],
      selectedId: -1
    }
  }

  componentDidMount() {
    fetch(API.getCategorys)
      .then(res => res.json())
      .then(
        (data) => {
          this.setState({category: data});
          let item = data.find(v=>v.id === InitConfig.categoryId);
          this.selected(item);
        }
      )
  }

  select(v){
    this.selected(v);
    Event.emit('ShowRight',1);
  }

  selected(v) {
    this.setState({selectedId: v.id});
    Event.emit('CategoryChange',v);
  }

  render() {
    return (
      <header className="header">
        <h1>莫兆記產品展示廳</h1>
        <ul className="top-menu">
          {
            this.state.category.map((v) => (
                <li key={v.id}>
                  <a className={v.id == this.state.selectedId ?'selected' : null}
                     onClick={this.select.bind(this,v)}>
                    {v.name}
                  </a>
                </li>
            ))
          }
        </ul>
      </header>
    );
  }
}